import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";
import Breadcrumbs from "../common/breadcrumbs";
import React from "react";
import ReportFilter from "./ReportFilter";
import { ClientRequest } from "http";
import Header from "../common/header";
import ReportList from "./ReportList";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";


const CustomerReport = () => {



  const { bookingStore: { pagination } } = useStore();
  const navigate = useNavigate();

  return (
    <>
   
      {/* Dashboard Header and Filters */}
    <div className="col-lg-12">
      <div className="row">

        <ReportFilter pageSize={pagination?.pageSize} />
    
      {/* Booking Grid View */}
      <section className="section booking-listing pt-0">
        <div className="container">
          <div className="row">
            <ReportList />
          </div>
        </div>
      </section>
        </div>
      </div>
      
    </>
  );
};

export default observer(CustomerReport);